// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import { Select, type SelectSize, type SelectVariant } from '../Select';
import styles from './FieldViewSelect.module.css';

export interface FieldViewSelectProps {
  id: string;
  /** The inline caption inside the well; it also names the select. */
  label: string;
  /** `fieldViewOptions`: the templates, then Alle felter. */
  options: readonly { value: string; label: string }[];
  /** The current view's wire form (`formatFieldView`). */
  value: string;
  onChange: (raw: string) => void;
  variant?: SelectVariant;
  size?: SelectSize;
  block?: boolean;
  /** Lands on the Select's wrapper (placement in the parent's layout). */
  className?: string;
}

/**
 * Which fields to show (`bygning/fieldView`): a native select over the
 * project's templates plus Alle felter, its caption inline before the value
 * as Tabel's Skabelon picker had it. Picking a view is not an edit, so it
 * stays enabled for a viewer.
 */
export function FieldViewSelect({
  id,
  label,
  options,
  value,
  onChange,
  variant = 'filled',
  size = 'md',
  block,
  className,
}: FieldViewSelectProps) {
  return (
    <Select
      variant={variant}
      size={size}
      block={block}
      className={className}
      prefix={
        <label htmlFor={id} className={styles.inlineLabel}>
          {label}
        </label>
      }
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </Select>
  );
}
